import { FeatureFlagApi } from "~/api/FeatureFlag";

export function useFeatureFlagsApi(): FeatureFlagApi {
  const featureFlagApi = new FeatureFlagApi(useHttpClient());

  return featureFlagApi;
}
